import { UXPage } from '../../core/models/ux-page';
import { Collapsable } from '../../catalog/models/collapsable';

export function createSideMenu(trail: UXPage[]): Collapsable[] {
    let topMenu = trail.reverse().find(menu => menu.menu === 'top')

    if(!topMenu || !topMenu.children.length) 
        return [] 

    let simpleTrail = trail.map(point => point.id)

    return onlySideMenu(topMenu)
        .map(createCollapsable.bind(this, simpleTrail))
}

function onlySideMenu(page: UXPage): UXPage[] {
    return page.children.filter(page => page.menu === 'side')
}

function createCollapsable(trail: string[], page: UXPage): Collapsable {
    return {
        name: page.name,
        applied: trail.indexOf(page.id) !== -1,
        slug: page.slug,
        children: onlySideMenu(page).map(createCollapsable.bind(this, trail))
    }
}
